// app/javascript/compcalc/components/JobDisplacement.jsx

import React from "react";
import PropTypes from "prop-types";
import { withStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import Paper from '@material-ui/core/Paper';

import Button from '@material-ui/core/Button';
import IconButton from '@material-ui/core/IconButton';
import Input from '@material-ui/core/Input';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormLabel from '@material-ui/core/FormLabel';
import MenuIcon from '@material-ui/icons/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { currencyFormatter } from '../utils';


const styles = theme => ({
  root: {
    flexGrow: 1,
    marginTop: theme.spacing(1),
  },
  wrapContent: {
    display: 'inline-block',
  },
  textField: {
    width: 100,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  textFieldAmount: {
    width: 150,
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
  alignCenter: {
    // background: 'green',
    display: 'flex',
    justifyContent: 'center',    // Horizontal align.
    alignItems: 'center',        // Vertical align.
  },
  alignLeft: {
    // background: 'blue',
    display: 'flex',
    flexFlow: 'row nowrap',
    alignItems: 'center',
  },
  alignRight: {
    // background: 'red',
    display: 'flex',
    flexFlow: 'row-reverse nowrap',
    alignItems: 'center',
  },
  paperStretch: {
    padding: theme.spacing(2),
  },
  paper: {
    padding: theme.spacing(2),
    display: 'inline-block',
  },
  pre: {
    width: '100%',
    maxWidth: '800px',
    whiteSpace: 'pre-wrap',
  }
});


class JobDisplacement extends React.PureComponent {

  constructor() {
    super();

    this.itemsYears = [
      (<MenuItem dense key={0} value={0}>2004 - 2012</MenuItem>),
      (<MenuItem dense key={1} value={1}>After 2013</MenuItem>),
    ];

    this.itemsPDs = [
      (<MenuItem dense key={0} value={0}>1% - 15%</MenuItem>),
      (<MenuItem dense key={1} value={1}>15% - 25%</MenuItem>),
      (<MenuItem dense key={2} value={2}>26% - 49%</MenuItem>),
      (<MenuItem dense key={3} value={3}>50% - 99%</MenuItem>),
    ];

    this.amounts = [
      [
        "$4,000",
        "$6,000",
        "$8,000",
        "$10,000",
      ],
      [
        "$6,000",
        "$6,000",
        "$6,000",
        "$6,000",
      ],
    ];

    this.state = {
      doi: 0,
      pd: 0,
      amount: 0,
      isExpanded: false,
    };
  }

  componentDidMount() {
    this.calculate();
  }

  onTextExpand = () => {
    this.setState({ isExpanded: !this.state.isExpanded });
  }

  onSelectChange = (event) => {
    // console.log(event.target.name, event.target.value);
    this.setState({ [event.target.name]: event.target.value }, this.calculate); // Alternative componentDidUpdate().
  };

  calculate = () => {
    this.setState({ amount: this.amounts[this.state.doi][this.state.pd] })
  }

  render() {
    const { classes } = this.props;

    return (
      <Grid container spacing={1} className={classes.root} justifyContent="center">

        <Grid item xs={6} className={classes.alignCenter}>
          {/* Date of Injury */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Date of Injury</FormLabel>
              <Select
                value={this.state.doi}
                onChange={this.onSelectChange}
                input={<Input id="doi" name="doi" />}
                autoWidth
              >
                { this.itemsYears }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={6} className={classes.alignCenter}>
          {/* PPD Award */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">PPD Award</FormLabel>
              <Select
                value={this.state.pd}
                onChange={this.onSelectChange}
                input={<Input id="pd" name="pd" />}
                autoWidth
              >
                { this.itemsPDs }
              </Select>
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          {/* Voucher Amount */}
          <Paper className={classes.paper}>
            <FormControl>
              <FormLabel component="legend">Voucher Amount</FormLabel>
              <TextField
                id="amount"
                value={this.state.amount}
                className={classes.textFieldAmount}
                margin="normal"
                InputProps={{ readOnly: true }}
              />
            </FormControl>
          </Paper>
        </Grid>

        <Grid item xs={12} className={classes.alignCenter}>
          <Paper className={classes.paper}>
            <div className={classes.pre}>
              <Typography variant="body1">
                <b>{jdText}</b>
                {jdText1}
              </Typography>
              {this.state.isExpanded && (
                <div>
                  <br/>
                  <Typography variant="body1">
                    {jdText11}
                    <b>{jdText2}</b>
                    {jdText3}
                  </Typography>
                </div>
              )}
              <div className={classes.alignRight}>
                <Button color="primary" onClick={this.onTextExpand}>
                    {this.state.isExpanded ? 'Less ...' : 'More ...'}
                </Button>
              </div>
            </div>
          </Paper>
        </Grid>

      </Grid>
    );
  }

};

export default withStyles(styles)(JobDisplacement);

const jdText = `§ 4658.1.  Meaning of "regular work", "modified work", and "alternative work"; Equivalent wages and compensation; location`;

const jdText1 = `

As used in this article, the following definitions apply:

 (a) "Regular work" means the employee's usual occupation or the position in which the employee was engaged at the time of injury and that offers wages and compensation equivalent to those paid to the employee at the time of injury, and located within a reasonable commuting distance of the employee's residence at the time of injury.

 (b) "Modified work" means regular work modified so that the employee has the ability to perform all the functions of the job and that offers wages and compensation that are at least 85 percent of those paid to the employee at the time of injury, and located within a reasonable commuting distance of the employee's residence at the time of injury.`;

const jdText11 = ` (c) "Alternative work" means work that the employee has the ability to perform, that offers wages and compensation that are at least 85 percent of those paid to the employee at the time of injury, and that is located within reasonable commuting distance of the employee's residence at the time of injury.

 (d) For the purpose of determining whether wages and compensation are equivalent to those paid at the time of injury, the wages and compensation for any increase in working hours over the average hours worked at the time of injury shall not be considered.

 (e) For the purpose of determining whether wages and compensation are equivalent to those paid at the time of injury, actual wages and compensation shall be determined without regard to the minimums and maximums set forth in Chapter 1 (commencing with Section 4451).

 (f) The condition that regular work, modified work, or alternative work be located within a reasonable distance of the employee's residence at the time of injury may be waived by the employee. The condition shall be deemed to be waived if the employee accepts the regular work, modified work, or alternative work and does not object to the location within 20 days of being informed of the right to object. The condition shall be conclusively deemed to be satisfied if the offered work is at the same location and the same shift as the employment at the time of injury.

`;

const jdText2 = `§ 4658.7.  Eligibility for supplemental job displacement for injuries occurring on or after January 1, 2013`;
const jdText3 = `

(a) This section shall apply to injuries occurring on or after January 1, 2013.

(b) If the injury causes permanent partial disability, the injured employee shall be entitled to a supplemental job displacement benefit as provided in this section unless the employer makes an offer of regular, modified, or alternative work, as defined in Section 4658.1, that meets both of the following criteria:

 (1) The offer is made no later than 60 days after receipt by the claims administrator of the first report received from either the primary treating physician, an agreed medical evaluator, or a qualified medical evaluator, in the form created by the administrative director pursuant to subdivision (h), finding that the disability from all conditions for which compensation is claimed has become permanent and stationary and that the injury has caused permanent partial disability.

   (A) If the employer or claims administrator has provided the physician with a job description of the employee's regular work, proposed modified work, or proposed alternative work, the physician shall evaluate and describe in the form whether the work capacities and activity restrictions are compatible with the physical requirements set forth in that job description.

   (B) The claims administrator shall forward the form to the employer for the purpose of fully informing the employer of work capacities and activity restrictions resulting from the injury that are relevant to potential regular, modified, or alternative work.

 (2) The offer is for regular work, modified work, or alternative work lasting at least 12 months.

(c) The supplemental job displacement benefit shall be offered to the employee within 20 days after the expiration of the time for making an offer of regular, modified, or alternative work pursuant to paragraph (1) of subdivision (b).

(d) The supplemental job displacement benefit shall be in the form of a voucher redeemable as provided in this section up to an aggregate of six thousand dollars ($6,000).

(e) The voucher may be applied to any of the following expenses at the choice of the injured employee:

 (1) Payment for education-related retraining or skill enhancement, or both, at a California public school or with a provider that is certified and on the state's Eligible Training Provider List (EPTL), as authorized by the federal Workforce Investment Act (P.L. 105-220), including payment of tuition, fees, books, and other expenses required by the school for retraining or skill enhancement.

 (2) Payment for occupational licensing or professional certification fees, related examination fees, and examination preparation course fees.

 (3) Payment for the services of licensed placement agencies, vocational or return-to-work counseling, and resume preparation, all up to a combined limit of 10 percent of the amount of the voucher.

 (4) Purchase of tools required by a training or educational program in which the employee is enrolled.

 (5) Purchase of computer equipment, up to one thousand dollars ($1,000).

 (6) Up to five hundred dollars ($500) as a miscellaneous expense reimbursement or advance, payable upon request and without need for itemized documentation or accounting. The employee shall not be entitled to any other voucher payment for transportation, travel expenses, telephone or Internet access, clothing or uniforms, or incidental expenses.

(f) The voucher shall expire two years after the date the voucher is furnished to the employee, or five years after the date of injury, whichever is later. The employee shall not be entitled to payment or reimbursement of any expenses that have not been incurred and submitted with appropriate documentation to the employer prior to the expiration date.

(g) Settlement or commutation of a claim for the supplemental job displacement benefit shall not be permitted under Chapter 2 (commencing with Section 5000) or Chapter 3 (commencing with Section 5100) of Part 3.

(h) The administrative director shall adopt regulations for the administration of this section, including, but not limited to, both of the following:

 (1) The time, manner, and content of notices of rights under this section.

 (2) The form of a mandatory attachment to a medical report to be forwarded to the employer pursuant to paragraph (1) of subdivision

(b) for the purpose of fully informing the employer of work capacities and of activity restrictions resulting from the injury that are relevant to potential regular work, modified work, or alternative work.

(i) An employer shall not be liable for compensation for injuries incurred by the employee while utilizing the voucher.`;
